var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper d-flex", class: { disabled: _vm.disabled } },
    [
      _c(
        "div",
        {
          staticClass:
            "button d-flex justify-content-center align-items-center",
          class: { disabled: _vm.isMinusDisabled || _vm.disabled },
          on: { click: _vm.onMinus },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/pricing/plans/minus.svg"),
              alt: "stars",
            },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "number d-flex justify-content-center align-items-center font-outfit-semi-bold",
        },
        [_c("span", [_vm._v(_vm._s(_vm.value))])]
      ),
      _c(
        "div",
        {
          staticClass:
            "button d-flex justify-content-center align-items-center",
          class: { disabled: _vm.isPlusDisabled || _vm.disabled },
          on: { click: _vm.onPlus },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/pricing/plans/plus.svg"),
              alt: "stars",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }